<template>
  <IconBase v-bind="$attrs">
    <path :d="svgIcon"></path>
  </IconBase>
</template>

<script>
import { mdiMenuUp, mdiMenuDown } from '@mdi/js';

export default {
  name: 'BuefyCustomSvgIcon',

  props: {
    icon: {
      type: Array,
      required: true,
    },
  },
  computed: {
    // NOTE: 使用するマテリアルデザインアイコンを追加する場合は以下に追記
    icons() {
      return {
        mdiMenuUp,
        mdiMenuDown,
      };
    },
    svgIcon() {
      return this.icons[`mdi${this.icon[1]}`];
    },
  },
};
</script>
